import {Component} from '@angular/core';
/**
 * \@title Basic progress-bar
 */
export class ProgressBarOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'progress-bar-overview-example',
  templateUrl: 'progress-bar-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProgressBarOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
ProgressBarOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProgressBarOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
